import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/:schema',
      name: 'home_schema',
      component: Home
  },
    {
      path: '/',
      name: 'home',
      component: Home
    }
  ]
})
